import { useMutation } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { DashboardsColumn, DashboardsPreviewRespSuccess, DashboardsSorting } from './types';
import { usePanelUrl } from './helpers';
import { useQueryParams } from '@hooks/queryParams';
import { DashboardsSourceType } from '@contexts/dashboards/types';

export const useGetDashboardsPreview = ({
  callback,
}: {
  callback: (data: DashboardsPreviewRespSuccess) => void;
}) => {
  const {
    params: { search },
    parseParams,
  } = useQueryParams();

  const queryParams = parseParams({ search });

  const opt = usePanelUrl(`dashboards/preview${queryParams}`);

  const { mutate, isPending } = useMutation({
    mutationFn: ({
      columns,
      sorting,
      scope,
    }: {
      columns: DashboardsColumn[];
      sorting: DashboardsSorting[];
      scope: DashboardsSourceType[];
    }): Promise<DashboardsPreviewRespSuccess> =>
      queryFetch({
        ...opt,
        data: { dashboard: { preset: { columns, sorting, scope } } },
        opt: { method: 'POST' },
      }),
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
    },
    onSettled: (data) => {
      if (!data) return;
      callback(data);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
